export default () => {
  document.querySelectorAll(".js-privacy-banner").forEach((el) => {
    const acceptBtn = document.querySelector(".js-accept-cookies");
    const closeBtn = document.querySelector(".js-close-banner");
    const body = document.querySelector("body");

    if (!getCookie("acceptPrivacy")) {
      el.classList.remove("is-hidden");

      handleResize();
      window.addEventListener("resize", handleResize);

      acceptBtn.addEventListener("click", (e) => {
        e.preventDefault();
        handlePrivacy(!body.classList.contains("is-page-editor"));
      });

      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        handlePrivacy(false);
      });
    }

    function handleResize() {
      let resizeHeight = el.offsetHeight;
      body.style.paddingBottom = `${resizeHeight}px`;
    }

    function handlePrivacy(accept) {
      if (accept) {
        //closed by accepting
        setCookie("acceptPrivacy", true, 90);
      } else {
        //closed without accepting
        setCookie("acceptPrivacy", false, 1);
      }

      body.style.paddingBottom = "0";

      window.removeEventListener("resize", handleResize);
    }

    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      //exdays from now
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      const expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";";
      el.classList.add("is-hidden");
    }

    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return false;
    }
  });
};
